import React, { useContext, useState } from 'react';
import { Link, StateContext, WeekData } from '../../StateContext';
import EditIcon from '@mui/icons-material/Edit';
import {
    Modal,
    Box,
    TextField,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { boxStyle } from '../../Pages/Projects/styles';
import { editWeekDataCall } from '../../Services/APICalls/apicalls';
import { hourToSeconds } from './addWeekOverview';
import { MechanicHourValue } from '../../Services/types';
import { IContextData } from '../../../App';
import { useLanguage } from '../../Services/LanguageContext';

interface IProps {
    weekData: WeekData;
    link: Link;
}

const secondsToHours = (seconds: number) => {
    return seconds / 3600;
};

const EditWeek = (props: IProps) => {
    const { loginData, setLoginData } = useContext<IContextData>(StateContext);
    const { t } = useLanguage();
    const [weekNumber, setWeekNumber] = useState(props.weekData.weekNumber);
    const [hoursWorked, setHoursWorked] = useState(secondsToHours(props.weekData.secondsWorked));
    const [year, setYear] = useState(props.weekData.year || new Date().getFullYear());

    const currentMechanic = loginData.mechanics.find(
        (x) => x.id === props.link.mechanicId
    );
    const project = loginData.projects.find((p) => p.id === props.link.projectId);
    const projectTypes = project?.types ?? [];

    const [hourWeight, setHourWeight] = useState<number | any>(
        props.weekData.weight || currentMechanic.defaultWeight
    );
    const [projectTypeId, setProjectTypeId] = useState<number | ''>(
        props.weekData.projectTypeId ?? ''
    );
    const [open, setOpen] = useState(false);

    const editWeekHandler = () => {
        const secondsWorked = hourToSeconds(hoursWorked);
        editWeekDataCall(
            props.link.projectId,
            props.weekData.id,
            secondsWorked,
            weekNumber,
            hourWeight,
            year,
            setLoginData,
            projectTypeId === '' ? null : projectTypeId
        );
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Tooltip title={t('edit')} arrow>
                <div className='cursor-pointer'>
                    <EditIcon onClick={() => setOpen(true)} />
                </div>
            </Tooltip>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Box style={boxStyle}>
                    <form
                        action='#'
                        className='flex flex-col items-center gap-3'
                        onSubmit={editWeekHandler}
                    >
                        <div>
                            <TextField
                                type='number'
                                label={t('weekNumber')}
                                value={weekNumber}
                                onChange={(x) => setWeekNumber(parseInt(x.target.value))}
                            />
                        </div>
                        <div>
                            <TextField
                                type='number'
                                label={t('year')}
                                value={year}
                                onChange={(x) => setYear(parseInt(x.target.value))}
                            />
                        </div>
                        <div>
                            <TextField
                                type='number'
                                label={t('hours')}
                                value={hoursWorked}
                                inputProps={{ maxLength: 13, step: '0.01' }}
                                onChange={(x) => setHoursWorked(parseFloat(x.target.value))}
                            />
                        </div>
                        <div>
                            <FormControl style={{ width: '220px' }}>
                                <InputLabel id='mechanic-type-select-label'>
                                    {t('percentToCount')}
                                </InputLabel>
                                <Select
                                    label={t('percentToCount')}
                                    labelId='hour-weight-select-label'
                                    id='hour-weight-select'
                                    value={hourWeight}
                                    onChange={(x) => setHourWeight(x.target.value)}
                                >
                                    {MechanicHourValue.map((type) => (
                                        <MenuItem key={type.value} value={type.value}>
                                            {type.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        {projectTypes.length > 0 && (
                            <div>
                                <FormControl style={{ width: '220px' }}>
                                    <InputLabel id='edit-project-type-select-label'>
                                        {t('workType')}
                                    </InputLabel>
                                    <Select
                                        label={t('workType')}
                                        labelId='edit-project-type-select-label'
                                        id='edit-project-type-select'
                                        value={projectTypeId}
                                        onChange={(x) => setProjectTypeId(x.target.value as number | '')}
                                    >
                                        <MenuItem value=''>{t('noType')}</MenuItem>
                                        {projectTypes.map((pt) => (
                                            <MenuItem key={pt.id} value={pt.id}>
                                                {pt.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        )}
                        <button style={{ width: '220px' }}>{t('edit')}</button>
                    </form>
                </Box>
            </Modal>
        </React.Fragment>
    );
};

export default EditWeek;
